// Timeline scroll functionality
function initTimelineScroll() {
    // Timeline scroll functionality is now handled by native browser scrolling
    // No additional JavaScript needed for free vertical scrolling
  }
  
  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initTimelineScroll();
  });
  
  // Reinitialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.bk-media-timeline-scrollable')) {
      initTimelineScroll();
    }
  });

  /**
 * BK-MEDIA CUSTOM FUNCTIONALITY
 * =============================
 * 
 * This file contains custom JavaScript functionality for the BK-Media theme.
 * It follows the user rules of keeping customizations separate from theme files.
 */

(function() {
  'use strict';

  /**
   * Timeline scroll functionality
   */
  function initTimelineScroll() {
    // Timeline scroll functionality is now handled by native browser scrolling
    // No additional JavaScript needed for free vertical scrolling
  }

  // Initialize timeline on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimelineScroll);
  } else {
    initTimelineScroll();
  }

  // Reinitialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.bk-media-timeline-scrollable')) {
      initTimelineScroll();
    }
  });

  /**
   * Custom Variant Rows functionality
   */
  let customVariantRowsInitialized = false;
  
  function initCustomVariantRows() {
    if (customVariantRowsInitialized) return;
    customVariantRowsInitialized = true;
    
    function handleVariantChange(e) {
      if (!e.detail || !e.detail.variant) return;
      
      const variantId = e.detail.variant.id.toString();
      const variantRows = document.querySelectorAll('.bk-media-custom-variant-row');
      
      variantRows.forEach(row => {
        if (row.getAttribute('data-variant-id') === variantId) {
          row.classList.add('is-selected');
          row.style.removeProperty('background-color');
        } else {
          row.classList.remove('is-selected');
        }
      });
      
      updateAccordionTitle(variantId);
    }
    
    function updateAccordionTitle(variantId) {
      const accordions = document.querySelectorAll('.bk-media-custom-variant-accordion');
      
      accordions.forEach(accordion => {
        const formId = accordion.closest('variant-picker')?.getAttribute('form-id');
        if (!formId) return;
        
        const variantNamesScript = document.querySelector(`script[data-variant-names="${formId}"]`);
        if (!variantNamesScript) return;
        
        const variantRow = accordion.querySelector(`.bk-media-custom-variant-row[data-variant-id="${variantId}"]`);
        if (!variantRow) return;
        
        const summary = accordion.querySelector('summary');
        if (!summary) return;
        
        const toggle = summary.querySelector('.bk-media-custom-variant-accordion__toggle');
        if (!toggle) return;
        
        try {
          const variantNames = JSON.parse(variantNamesScript.textContent);
          const customName = variantNames[variantId];
          
          const leftSection = toggle.querySelector('.bk-media-custom-variant-row__left');
          const rightSection = toggle.querySelector('.bk-media-custom-variant-accordion__right');
          
          if (leftSection) {
            const nameElement = leftSection.querySelector('.bk-media-custom-variant-row__name');
            if (nameElement && customName) {
              nameElement.textContent = customName;
            }
            
            const unitPriceElement = leftSection.querySelector('.bk-media-custom-variant-row__unit-price');
            const variantUnitPrice = variantRow.querySelector('.bk-media-custom-variant-row__unit-price');
            if (variantUnitPrice) {
              if (unitPriceElement) {
                unitPriceElement.innerHTML = variantUnitPrice.innerHTML;
              } else {
                const newUnitPrice = variantUnitPrice.cloneNode(true);
                leftSection.appendChild(newUnitPrice);
              }
            } else if (unitPriceElement) {
              unitPriceElement.remove();
            }
          }
          
          if (rightSection) {
            const variantBestseller = variantRow.querySelector('.bk-media-custom-variant-row__bestseller-badge');
            const variantSavings = variantRow.querySelector('.bk-media-custom-variant-row__savings-badge');
            const variantPrices = variantRow.querySelector('.bk-media-custom-variant-row__prices');
            
            let bestsellerElement = rightSection.querySelector('.bk-media-custom-variant-row__bestseller-badge');
            let savingsElement = rightSection.querySelector('.bk-media-custom-variant-row__savings-badge');
            let pricesElement = rightSection.querySelector('.bk-media-custom-variant-row__prices');
            const chevron = rightSection.querySelector('.circle-chevron');
            
            if (variantBestseller) {
              if (bestsellerElement) {
                bestsellerElement.innerHTML = variantBestseller.innerHTML;
                const bestsellerStyle = variantBestseller.getAttribute('style');
                if (bestsellerStyle) {
                  bestsellerElement.setAttribute('style', bestsellerStyle);
                } else {
                  bestsellerElement.removeAttribute('style');
                }
              } else {
                const newBestseller = variantBestseller.cloneNode(true);
                const insertBeforeElement = rightSection.querySelector('.bk-media-custom-variant-row__savings-badge') || rightSection.querySelector('.bk-media-custom-variant-row__prices') || chevron;
                if (insertBeforeElement) {
                  rightSection.insertBefore(newBestseller, insertBeforeElement);
                } else {
                  rightSection.appendChild(newBestseller);
                }
                bestsellerElement = newBestseller;
              }
            } else if (bestsellerElement) {
              bestsellerElement.remove();
              bestsellerElement = null;
            }
            
            if (variantSavings) {
              if (savingsElement) {
                savingsElement.innerHTML = variantSavings.innerHTML;
                if (variantSavings.style.backgroundColor) {
                  savingsElement.style.backgroundColor = variantSavings.style.backgroundColor;
                }
              } else {
                const newSavings = variantSavings.cloneNode(true);
                if (chevron) {
                  rightSection.insertBefore(newSavings, chevron);
                } else {
                  rightSection.appendChild(newSavings);
                }
                savingsElement = newSavings;
              }
            } else if (savingsElement) {
              savingsElement.remove();
            }
            
            if (variantPrices) {
              if (pricesElement) {
                pricesElement.innerHTML = variantPrices.innerHTML;
              } else {
                const newPrices = variantPrices.cloneNode(true);
                if (chevron) {
                  rightSection.insertBefore(newPrices, chevron);
                } else {
                  rightSection.appendChild(newPrices);
                }
                pricesElement = newPrices;
              }
            }
          }
        } catch (error) {
          console.error('Failed to update accordion:', error);
        }
      });
    }
    
    function initializeSelectedState() {
      const variantRows = document.querySelectorAll('.bk-media-custom-variant-row.is-selected');
      variantRows.forEach(row => {
        row.style.removeProperty('background-color');
        const variantId = row.getAttribute('data-variant-id');
        if (variantId) {
          updateAccordionTitle(variantId);
        }
      });
      
      const forms = document.querySelectorAll('form[id^="product-form"]');
      forms.forEach(form => {
        const variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput && variantIdInput.value) {
          updateAccordionTitle(variantIdInput.value);
        }
      });
    }
    
    function attachRowListeners() {
      const variantRows = document.querySelectorAll('.bk-media-custom-variant-row:not([data-listener-attached])');
      
      variantRows.forEach(row => {
        row.setAttribute('data-listener-attached', 'true');
        
        row.addEventListener('click', function(e) {
          if (this.classList.contains('is-disabled')) return;
          
          e.stopPropagation();
          
          const variantId = this.getAttribute('data-variant-id');
          if (!variantId) return;
          
          const form = this.closest('form') || document.querySelector(`form[id^="product-form"]`);
          if (!form) return;
          
          const variantInputs = form.querySelectorAll(`input[data-variant-id="${variantId}"]`);
          
          variantInputs.forEach(input => {
            if (input.type === 'radio') {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          
          const accordion = this.closest('.bk-media-custom-variant-accordion');
          if (accordion && !accordion.hasAttribute('open')) {
            accordion.setAttribute('open', '');
          }
        });
      });
    }
    
    attachRowListeners();
    initializeSelectedState();
    document.addEventListener('variant:change', handleVariantChange);
    
    document.addEventListener('shopify:section:load', function() {
      customVariantRowsInitialized = false;
      initCustomVariantRows();
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomVariantRows);
  } else {
    initCustomVariantRows();
  }


  /**
   * Gallery USP Popup Functionality
   * Handles the popup interactions for the gallery USP section
   */
  function initGalleryUSPPopup() {
    const popupOverlay = document.getElementById('gallery-popup-overlay');
    const popupTriggers = document.querySelectorAll('[data-popup-trigger]');
    const carouselTriggers = document.querySelectorAll('[data-carousel-popup-trigger]');
    const popupClose = document.querySelector('.bk-media-gallery-popup-close');
    const popupPanels = document.querySelectorAll('[data-popup-panel]');

    if (!popupOverlay || (popupTriggers.length === 0 && carouselTriggers.length === 0)) {
      return;
    }

    // Open popup function
    function openPopup(panelIndex) {
      // Hide all panels first
      popupPanels.forEach(panel => {
        panel.classList.remove('active');
        panel.style.display = 'none';
      });

      // Show the selected panel
      const targetPanel = document.querySelector(`[data-popup-panel="${panelIndex}"]`);
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.style.display = 'block';
      }

      // Show overlay
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    // Close popup function
    function closePopup() {
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Event listeners for gallery popup triggers
    popupTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const panelIndex = trigger.getAttribute('data-popup-trigger');
        openPopup(panelIndex);
      });
    });

    // Event listeners for carousel popup triggers
    carouselTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const panelIndex = trigger.getAttribute('data-carousel-popup-trigger');
        openPopup(panelIndex);
      });
    });

    // Event listener for close button
    if (popupClose) {
      popupClose.addEventListener('click', closePopup);
    }

    // Event listener for overlay click (close popup)
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        closePopup();
      }
    });

    // Event listener for escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popupOverlay.classList.contains('active')) {
        closePopup();
      }
    });
  }

  // Initialize gallery USP popup when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryUSPPopup);
  } else {
    initGalleryUSPPopup();
  }

  // Re-initialize on section reload (for dynamic content)
  document.addEventListener('shopify:section:load', initGalleryUSPPopup);

  /**
   * Handle USP positioning when variants change
   * This ensures USPs are redistributed to visible images in correct order
   */
  function handleUSPPositioning() {
    // Find all product galleries
    const productGalleries = document.querySelectorAll('product-gallery');
    
    productGalleries.forEach(gallery => {
      const form = document.forms[gallery.getAttribute('form')];
      if (form) {
        form.addEventListener('variant:change', function(event) {
          // Small delay to ensure the gallery has updated its media display
          setTimeout(() => {
            // Get all visible media elements (not hidden by variant filtering)
            const visibleMediaElements = Array.from(gallery.querySelectorAll('.product-gallery__media')).filter(media => 
              !media.hasAttribute('hidden')
            );
            
            // Get all USP items
            const allUSPItems = gallery.querySelectorAll('.bk-media-gallery-usp-item');
            
            // Hide all USPs first
            allUSPItems.forEach(uspItem => {
              uspItem.style.display = 'none';
            });
            
            // Redistribute USPs to visible media in order
            visibleMediaElements.forEach((mediaElement, index) => {
              // Find the USP that should be on this position
              const targetUSP = Array.from(allUSPItems).find(usp => 
                parseInt(usp.getAttribute('data-visible-position')) === index + 1
              );
              
              if (targetUSP) {
                // Move the USP to this media element
                mediaElement.appendChild(targetUSP);
                targetUSP.style.display = '';
                // Update the data attributes
                targetUSP.setAttribute('data-visible-position', index + 1);
                targetUSP.setAttribute('data-usp-index', index);
              }
            });
            
            // Re-initialize USP popup functionality
            initGalleryUSPPopup();
          }, 100);
        });
      }
    });
  }

  // Initialize USP positioning when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleUSPPositioning);
  } else {
    handleUSPPositioning();
  }

  // Also handle dynamic content loading
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('product-gallery')) {
      handleUSPPositioning();
    }
  });

  /**
   * Unit Price Text Replacement
   * Replaces "pro Stück" with "pro Packung" in all unit-price elements
   */
  function updateUnitPriceText() {
    const unitPriceElements = document.querySelectorAll('unit-price');
    unitPriceElements.forEach(element => {
      if (element.textContent.includes('pro Stück')) {
        element.textContent = element.textContent.replace(/pro Stück/g, 'pro Packung');
      }
    });
  }

  // Initialize unit price text replacement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUnitPriceText);
  } else {
    updateUnitPriceText();
  }

  // Re-run on section load and variant changes
  document.addEventListener('shopify:section:load', updateUnitPriceText);
  document.addEventListener('variant:change', function() {
    setTimeout(updateUnitPriceText, 100);
  });

  // Use MutationObserver to catch dynamically added unit-price elements
  const observer = new MutationObserver(function(mutations) {
    updateUnitPriceText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function bkMediaGetCartDrawerSectionId() {
    const drawer = document.getElementById('cart-drawer');
    const section = drawer?.closest('.shopify-section');
    return section?.id?.replace(/^shopify-section-/, '') || '';
  }

  function bkMediaCartApiRoot() {
    let r = '';
    if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) {
      r = String(Shopify.routes.root);
    } else if (
      typeof window.Shopify !== 'undefined' &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      r = String(window.Shopify.routes.root);
    }
    if (!r) {
      return '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function bkMediaPathFirstLink(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (let i = 0; i < path.length; i++) {
      const n = path[i];
      if (
        n &&
        n.nodeType === 1 &&
        n.tagName === 'A' &&
        n.getAttribute &&
        n.getAttribute('href')
      ) {
        return n;
      }
    }
    const t =
      event.target instanceof Element ? event.target : event.target.parentElement;
    return t && t.closest ? t.closest('a[href]') : null;
  }

  function bkMediaIsCartChangeHref(href) {
    if (!href) {
      return false;
    }
    return String(href).indexOf('cart/change') !== -1;
  }

  function bkMediaIsCartPageHref(href) {
    if (!href || href === '#' || href.indexOf('#') === 0) {
      return false;
    }
    try {
      const u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) {
        return false;
      }
      if (String(u.pathname).indexOf('cart/change') !== -1) {
        return false;
      }
      const norm = u.pathname.replace(/\/+$/, '') || '/';
      return /\/cart$/.test(norm);
    } catch (e) {
      return false;
    }
  }

  function bkMediaCartDrawerMode() {
    return (
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.cartType !== 'page'
    );
  }

  function bkMediaPerformCartChange(activator, lineKey, targetQuantity, opts) {
    opts = opts || {};
    const apiRoot = bkMediaCartApiRoot();
    const lineItem = activator.closest('line-item');
    const lineItemQty = activator.closest('line-item-quantity');
    const drawerHost = document.getElementById('cart-drawer');
    const fromCartDrawer = !!(drawerHost && drawerHost.contains(activator));
    lineItem?.dispatchEvent(
      new CustomEvent('line-item:will-change', {
        bubbles: true,
        detail: { targetQuantity: targetQuantity }
      })
    );
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    return fetch(apiRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity,
        sections: sectionsToBundle
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (responseContent) {
          lineItem?.querySelector('[role="alert"]')?.remove();
          const mount = lineItem?.querySelector('.line-item__info') || lineItem;
          const errorSvg =
            '<svg width="14" viewBox="0 0 18 18"><path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#eb001b"></path><path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path></svg>';
          mount?.insertAdjacentHTML(
            'beforeend',
            '<p class="text-with-icon text-error text-xs" role="alert">' +
              errorSvg +
              ' ' +
              (responseContent.description || '') +
              '</p>'
          );
          lineItem?.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
          const qtyInput = lineItemQty?.querySelector('.quantity-input');
          if (qtyInput) {
            qtyInput.value = qtyInput.defaultValue;
          }
          throw new Error(responseContent.description);
        });
      }
      return response.json();
    }).then(async function (cartContent) {
      if (
        !opts.forceAjax &&
        !fromCartDrawer &&
        window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.pageType === 'cart'
      ) {
        window.location.reload();
        return;
      }
      if (opts.forceAjax || fromCartDrawer) {
        const sectionId = bkMediaGetCartDrawerSectionId();
        if (
          sectionId &&
          (!cartContent.sections || !cartContent.sections[sectionId])
        ) {
          try {
            const secRes = await fetch(
              apiRoot + '?section_id=' + encodeURIComponent(sectionId)
            );
            const secHtml = await secRes.text();
            if (secHtml) {
              cartContent.sections = cartContent.sections || {};
              cartContent.sections[sectionId] = secHtml;
            }
          } catch (e) {}
        }
      }
      const lineItemAfterChange = cartContent.items.filter(function (item) {
        return item.key === lineKey;
      });
      lineItem?.dispatchEvent(
        new CustomEvent('line-item:change', {
          bubbles: true,
          detail: {
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
            cart: cartContent
          }
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart: cartContent
          }
        })
      );
    }).catch(function () {
      lineItem?.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
    });
  }

  window.addEventListener(
    'click',
    function (event) {
      if (!bkMediaCartDrawerMode()) {
        return;
      }
      const link = bkMediaPathFirstLink(event);
      if (!link) {
        return;
      }
      const hrefAttr = link.getAttribute('href') || '';

      if (bkMediaIsCartChangeHref(hrefAttr) || String(link.href).indexOf('cart/change') !== -1) {
        event.preventDefault();
        event.stopPropagation();
        if (link.getAttribute('data-bk-cart-change-busy') === 'true') {
          return;
        }
        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (e) {
          return;
        }
        const lineKey = url.searchParams.get('id');
        const qtyParam = url.searchParams.get('quantity');
        const targetQty =
          qtyParam === null || qtyParam === '' ? NaN : parseInt(qtyParam, 10);
        if (!lineKey || Number.isNaN(targetQty)) {
          return;
        }
        link.setAttribute('data-bk-cart-change-busy', 'true');
        bkMediaPerformCartChange(link, lineKey, targetQty, { forceAjax: true }).finally(
          function () {
            link.removeAttribute('data-bk-cart-change-busy');
          }
        );
        return;
      }

      if (bkMediaIsCartPageHref(hrefAttr)) {
        event.preventDefault();
        event.stopPropagation();
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
        }
      }
    },
    true
  );

})();